const pacotes = {
  negocios: "Negócios",
  estrategico: "Estratégico",
};

export default pacotes;
